<template>
  <div class="badge" :class="[`badge--${variant}`]">
    <span class="badge__label">{{ label }}</span>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: "Badge",
  props: {
    /**
     * Badge variant based on color scheme.
     * Options: 'blue-light' | 'yellow-light' | 'purple' | 'green-dark' | 'blue-dark' | 'pink-dark'
     */
    variant: {
      type: String,
      default: "blue-light",
      validator: (value) =>
        [
          "blue-light",
          "yellow-light",
          "purple",
          "green-dark",
          "blue-dark",
          "pink-dark",
        ].includes(value),
    },
    /**
     * Text label to display inside the badge.
     */
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
@import "@/assets/css/colors.css";

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 999px;
}

.badge__label {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-small);
  line-height: 20px;
  letter-spacing: 0.042px;
  white-space: nowrap;
}

/* --- Variants --- */

/* Free — light blue bg, blue text */
.badge--blue-light {
  background-color: var(--badge-blue-light-1);
  color: var(--blue-medium);
}

/* Popular / Curriculum Connect — light yellow bg, black body text */
.badge--yellow-light {
  background-color: var(--yellow-2);
  color: var(--black-body-text);
}

/* TrendX — light purple bg, dark purple text */
.badge--purple {
  background-color: var(--purple-light-2);
  color: var(--purple-dark-2);
}

/* Tinker Kit — dark green bg, light green text */
.badge--green-dark {
  background-color: var(--green-dark-1);
  color: var(--green-light-1-badge);
}

/* Creator Kit — dark blue bg, light blue text */
.badge--blue-dark {
  background-color: var(--blue-dark-1);
  color: var(--blue-light-1);
}

/* Invention Kit — dark pink bg, light pink text */
.badge--pink-dark {
  background-color: var(--pink-dark-1);
  color: var(--pink-light-1);
}
</style>
